import React from 'react'
import { RichTextField, DataLink } from '../prismic-elements'
import { LazySection } from '..'

import './RichTextWithBackground.sass'

const RichTextWithBackground = ({ slice, className }) => {
  let style = slice.primary.image.url ? { '--background': `url(${slice.primary.image.url})` } : null
  if (slice.primary.image.url == "https://mca-website.cdn.prismic.io/mca-website/9977129f-d01c-4921-b364-446b1f2ad59e_mca-watermark.svg"
    || slice.primary.image.url == "https://mca-website.cdn.prismic.io/mca-website/ab81936a-f1d0-46bd-aa50-84dddc16dfb5_mca-logo.svg"
    || slice.primary.image.url == "https://images.prismic.io/mca-website/feed4673-bbb0-42c5-8e90-6c9ab8bf68b2_MCAlifesciences_watermarks.png?auto=format,compress"
    || slice.primary.image.url == "https://images.prismic.io/mca-website/d9aaf865-1fbe-453b-8ed7-e46081ab5d95_MCAblanc.png?auto=format,compress"
    || slice.primary.image.url == "https://images.prismic.io/mca-website/9e100ed9-af9b-43ac-bf90-c75c38922864_LOGO+MCA+ITALIA+NERO.png?auto=format,compress"
  )
  {
    style = null
  }

  return (
    <LazySection
      className={`section section-richtext-with-background ${className} ${slice.slice_label || ''}`}
      style={style}
    >
      <div className='is-narrow w-container'>
        <RichTextField field={slice.primary.title} Component='h2' className='section-title' />
        <div className='section-richtext w-richtext'>
          <RichTextField field={slice.primary.rich_text} />
        </div>
        {slice.primary.cta_link.url &&
          <DataLink prismicLink={slice.primary.cta_link} className='button w-inline-block'>
            <div>{slice.primary.cta_label}</div>
          </DataLink>}
      </div>
    </LazySection>
  )
}

export default RichTextWithBackground
